import { DefaultTheme } from 'styled-components'

const Theme: DefaultTheme = {
  darkBg: '#212529',
  lightBg: '#ffffff',

  colors: {
    primary: '#E6007A',
    success: '#28a745',
    danger: '#dc3545', 
    secondary: '#01FFFF',
    white: '#FFFFFF',
    black: '#212529',
    grey: '#ced4da',
    lightGrey: '#6c757d',
    darkGrey: '#343A40'
  }
}

export { Theme }
